// extracted by mini-css-extract-plugin
module.exports = {"directoryImage":"Teleport_directoryImage__Gpj-h","teleportImage":"Teleport_teleportImage__kbqnF","closeDiv":"Teleport_closeDiv__2JFXV"};